<template>
  <multiselect
    v-model="selected"
    :hide-selected="true"
    tag-placeholder="Select users to share"
    placeholder="Add users' email to share"
    label="email"
    track-by="email"
    :options="options"
    :multiple="true"
    :taggable="true"
    :loading="isLoadingElem > 0"
    class="email-sharing-multiselect"
    @tag="addTag"
  >
    <template #tag="{ option, remove }">
      <span
        v-if="option.name !== null"
        class="custom-tag"
        :class="{ 'editor-user': option.accesstype }"
      ><span>{{
         option.name
       }}</span>
        <ToggleButton
          v-model="option.accesstype"
          class="my-0 mx-1"
          :value="true"
          :labels="{ checked: 'Editor', unchecked: 'Viewer' }"
          :width="60"
          :height="20"
        />
        <span
          class="custom-remove m-1"
          @click="remove(option)"
        >❌</span>
      </span>
      <span
        v-else
        class="custom-tag invitation-tag"
        :class="{ 'editor-invitation': option.accesstype }"
      ><span>{{
         option.email
       }}-[Invitation]</span>
        <ToggleButton
          v-model="option.accesstype"
          class="my-0 mx-1"
          :value="true"
          :labels="{ checked: 'Editor', unchecked: 'Viewer' }"
          :width="60"
          :height="20"
        />
        <span
          class="custom-remove m-1"
          @click="remove(option)"
        >❌</span>
      </span>
    </template>
  </multiselect>
</template>

<script>
import {mapActions} from 'vuex'
import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'

const zoneNotify = 'Email Multiselect'

export default {
    components: {
		Multiselect,
		ToggleButton
	},
    props: ['initialSelected'],
    data() {
        return {
            selected: [...this.initialSelected],
            options: [...this.initialSelected],
            isLoading: [],
            isLoadingElem: 0,
        }
    },
    methods: {
        ...mapActions([
			'retrieveBasicUserDataMiddlewareAuth',
            'getEmailMiddlewareAuth'
		]),
        emailValidation(email) {
			return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
		},
        async addTag(newTag) {
			const splitNewTag = newTag.split(/[\n\r ]/)
			if (splitNewTag.length > 1) {
				splitNewTag.forEach(tag => { this.addTag(tag) });
				return
			}
			try {
				if (this.getEmailMiddlewareAuth === newTag) {
					const infoTitle = 'Not valid entry'
					const infoText = 'You have entered your own email'
					this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO, infoTitle, infoText, zoneNotify)
					return
				}
				if (!this.emailValidation(newTag)) {
					const errTitle = 'Not valid entry'
					const errText = `The element '${newTag}' is not a valid mail`
					this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify)
					return
				}
				await this.addUserToList(newTag)
			} catch (error) {

				const errTitle = 'Not valid entry'
				const errText = 'Error while adding the user. Please try again in a few minutes.'
				this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify)
			}
		},
        async addUserToList(newEmail, accesstype = true) {
			try {
				this.isLoadingElem++
				const userData = await this.retrieveBasicUserDataMiddlewareAuth({
					email: newEmail,
				});
				const tag = {
					email: newEmail,
					name: null,
					accesstype: accesstype
				}
				if (!userData.success) {
					const infoTitle = 'Undentified user'
					const infoText = `The email '${newEmail}' does not have an account in djuli.`
					this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO, infoTitle, infoText, zoneNotify)
					return
				}
				tag.name = userData.data.displayName
				if (typeof (this.options.find(t => t.email === tag.email)) !== 'undefined') {
					const warnTitle = 'Adding duplicate values'
					const warnText = `The email '${newEmail}' is already included`
					this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, zoneNotify)
					return
				}
				this.options.push(tag)
				this.selected.push(tag)
                this.$emit('emailAdded', this.options)
			} catch (error) {

				const errTitle = 'Not valid entry'
				const errText = 'Error while adding the user. Please try again in a few minutes.'
				this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify)
			} finally {
				this.isLoadingElem--
			}
		}
    },
	watch: {
			selected(newSelected) {
				this.$emit('userAdded', newSelected)
			}
	}
    
}

</script>

<style scoped>
</style>